import {Component, Input} from '@angular/core';
import {Notification} from 'src/app/models/notification/notification';
import {RouterSegments} from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import {SidenavService} from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.scss'],
    standalone: false
})
export class NotificationCardComponent {
  @Input() notification: Notification;

  tenant: string;
  RouterSegments = RouterSegments;

  constructor(private authService: AuthService, private sidenavService: SidenavService) {
    this.tenant = this.authService.principal.provider;
  }

}
